import React from "react";
import brandDummy from "../../assets/images/ourwork/hki.png";

/**
 * The one non-media cell in the collage — plays the same role the wordmark
 * tile plays in the reference grid: a resting point that reads as identity,
 * not content. Carries a placeholder still so it reveals/parallaxes like
 * every other tile instead of sitting flat.
 */
const BrandTile = ({ col, rowStart, rowSpan }) => (
  <article
    className="ow-tile"
    style={{ "--col": col, "--row": `${rowStart} / span ${rowSpan}` }}
    data-tile
  >
    <div className="ow-frame ow-frame--brand">
      <div className="ow-media" data-parallax>
        <img src={brandDummy} alt="HKI Media" loading="lazy" decoding="async" />
      </div>
      <span className="ow-veil" aria-hidden="true" />
      <div className="ow-brand">
        <span className="ow-brand-mark">HKI</span>
        <span className="ow-brand-sub">Media</span>
      </div>
    </div>
  </article>
);

export default BrandTile;
